import { acceptJsonHeaders, csrfHeaders, handleJson, jsonHeaders } from "@/lib/json-request"

export type ShotFrameCaptureStatus = "pending" | "processing" | "ready" | "failed"

export type ShotFrameCaptureRow = {
  id: number
  shot_id: number
  /** Версия клипа-источника; null — legacy-видео без версии или версия удалена. */
  version_id: number | null
  /** Позиция кадра в координатах исходного видео версии (не таймлайна). */
  timecode_ms: number
  status: ShotFrameCaptureStatus
  error_message: string | null
  image_url: string | null
  image_thumb_url: string | null
  image_download_url: string | null
  created_at: string
}

export async function listShotFrameCaptures(
  projectId: number,
  shotId: number,
  options?: { signal?: AbortSignal },
): Promise<ShotFrameCaptureRow[]> {
  const res = await fetch(`/projects/${projectId}/workspace/shots/${shotId}/frame_captures`, {
    credentials: "same-origin",
    signal: options?.signal,
    headers: acceptJsonHeaders(),
  })
  const data = await handleJson<{ captures: ShotFrameCaptureRow[] }>(res)
  return data.captures
}

export async function createShotFrameCapture(
  projectId: number,
  shotId: number,
  params: { ms: number; versionId: number | null },
): Promise<ShotFrameCaptureRow> {
  const res = await fetch(`/projects/${projectId}/workspace/shots/${shotId}/frame_captures`, {
    method: "POST",
    credentials: "same-origin",
    headers: jsonHeaders(),
    body: JSON.stringify({ ms: params.ms, version_id: params.versionId }),
  })
  const data = await handleJson<{ ok: boolean; capture: ShotFrameCaptureRow }>(res)
  return data.capture
}

export async function deleteShotFrameCapture(projectId: number, shotId: number, captureId: number): Promise<void> {
  const res = await fetch(`/projects/${projectId}/workspace/shots/${shotId}/frame_captures/${captureId}`, {
    method: "DELETE",
    credentials: "same-origin",
    headers: csrfHeaders(),
  })
  await handleJson<{ ok: boolean }>(res)
}
